"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KEY_CODE = {
    BACKSPACE: 8,
    DELETE: 46,
    ENTER: 13
};
exports.TIME_VALUES = {
    MASK_DELAY: 800
};
//# sourceMappingURL=constants.js.map